import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicLeasingService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public addQuote(id: number, quote: Record<string, unknown>): Observable<unknown> {
    const payload = {
      ...quote,
      url_origen: quote.url_origen ?? "/crm",
      auto_tipo_uso: quote.auto_tipo_uso ?? "personal",
      tipo: quote.tipo ?? "dealer",
    };
    return this.publicHttp
      .post(`/api/public/persons/${id}/quotes/single_quote`, payload)
      .pipe(tap((_) => console.log("LeasingPublicService.addQuote: Ok.")));
  }

  public putQuote(id, quote): Observable<any> {
    return this.publicHttp
      .put(`/api/public/quotes/${id}`, quote)
      .pipe(tap((_) => console.log("LeasingPublicService.putQuote: Ok.")));
  }

  public getLeasing({
    id,
    residual_value = 0,
    insurance_plan = "contado",
    insurance_amount = 0,
    new_asset = undefined,
    term = undefined,
    year = new Date().getFullYear().toString(),
    car_use = "personal",
    forced_profile = undefined,
    price = 0,
    downpayment = 0,
    locator = false,
    modelo_id = undefined,
    income = undefined,
    expenses = undefined,
    locator_monthly_rent = undefined,
    locator_installation_fee = undefined,
    opening_percentage = undefined,
    deposit_percentage = undefined,
    siting_state_id = undefined,
    old = undefined,
    product = undefined,
    financed_accessories = undefined,
    apply_subsidy = undefined,
    version_id = undefined,
  }): Observable<any> {
    const options = {
      params: {
        downpayment: String(downpayment),
        term,
        price: String(price),
        auto_tipo_uso: car_use,
        year,
        residual_value: String(residual_value),
        insurance_plan,
        insurance_amount: String(insurance_amount),
        new_asset,
        locator: (locator == null ? true : locator).toString(),
        forced_profile,
        modelo_id,
        ingresos_comprobables: income,
        expenses,
        locator_monthly_rent,
        locator_installation_fee,
        opening_percentage,
        deposit_percentage,
        siting_state_id,
        old,
        product,
        financed_accessories,
        apply_subsidy,
        version_id,
      },
    };
    return this.publicHttp
      .get(`/api/public/persons/${  id  }/leasings/leasing`, options)
      .pipe(tap((_) => console.log("LeasingPublicService.getLeasing: Ok")));
  }
}
